import { Box, Stack, styled, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const StyledFeaturesContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(1, 3, 3, 3),
  [theme.breakpoints.down('desktop')]: {
    padding: theme.spacing(0, 2),
  },
}));

export const StyledHiddenFeaturesContainer = styled(Stack)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.down('desktop')]: {
    padding: theme.spacing(0, 2, 2, 2),
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
  })
);

export const StyledKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(
  ({ theme }) => ({
    color: theme.palette.secondary.main,
  })
);
